import { themeColor } from "./_helpers";

export const bgTokens = {
  solid: themeColor({
    base: "{colors.white}",
    _themeBlack: "{colors.dark.800}",
    _themeWhite: "{colors.white}",
  }),
  heading: themeColor({
    base: "{colors.neutral.50}",
    _themeBlack: "{colors.blackAlpha.600}",
    _themeWhite: "{colors.neutral.50}",
  }),
  subHeading: themeColor({
    base: "{colors.neutral.100}",
    _themeBlack: "{colors.blackAlpha.100}",
    _themeWhite: "{colors.neutral.100}",
  }),
  surface: themeColor({
    base: "{colors.white}",
    _themeBlack: "{colors.dark.800}",
    _themeWhite: "{colors.white}",
  }),
  subtle: themeColor({
    base: "{colors.neutral.50}",
    _themeBlack: "{colors.blackAlpha.600}",
    _themeWhite: "{colors.neutral.50}",
  }),
  muted: themeColor({
    base: "{colors.neutral.100}",
    _themeBlack: "{colors.blackAlpha.100}",
    _themeWhite: "{colors.neutral.100}",
  }),
  inverse: themeColor({
    base: "{colors.neutral.900}",
    _themeBlack: "{colors.black}",
    _themeWhite: "{colors.neutral.900}",
  }),
  overlay: themeColor({
    base: "{colors.whiteAlpha.800}",
    _themeBlack: "{colors.blackAlpha.800}",
    _themeWhite: "{colors.whiteAlpha.800}",
  }),
  elevated: themeColor({
    base: "{colors.white}",
    _themeBlack: "{colors.dark.700}",
    _themeWhite: "{colors.white}",
  }),
};
